(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mmr-footer-menu')) {
    customElements.define('mmr-footer-menu', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected) return;
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        if (!this.details || !this.summary) return;
        this.media = window.matchMedia('(min-width: 768px)');
        this.sync = () => {
          const confirm = location.hash === '#footer-signup_form' && this.querySelector('#footer-signup_form');
          this.details.open = this.media.matches || Boolean(confirm);
          this.summary.tabIndex = this.media.matches ? -1 : 0;
        };
        this.preventDesktop = (event) => { if (this.media.matches) event.preventDefault(); };
        this.summary.addEventListener('click', this.preventDesktop);
        this.media.addEventListener('change', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.media?.removeEventListener('change', this.sync);
        this.summary?.removeEventListener('click', this.preventDesktop);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('mmr-navigation')) {
  customElements.define('mmr-navigation', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('[data-mmr-dialog]');
      this.opener = this.closest('store-header').querySelector('[data-mmr-open]');
      this.desktop = this.querySelector('.mmr-desktop-nav');
      this.media = matchMedia('(min-width: 769px)');
      this.roots = [...this.querySelectorAll('[data-mmr-root]')];

      this.opener.addEventListener('click', event => {
        event.preventDefault();
        this.openDrawer();
      }, options);

      this.addEventListener('click', event => {
        clearTimeout(this.hoverTimer);
        clearTimeout(this.leaveTimer);
        if (event.target.closest('[data-mmr-close]')) {
          this.closeDrawer();
        } else if (event.target.closest('a')) {
          this.closeDesktop();
          if (this.dialog.open) this.closeDrawer(false);
        }
      }, options);

      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
          this.closeDrawer();
        }
      }, options);

      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.closeDrawer();
      }, options);

      this.dialog.addEventListener('close', () => this.releaseDrawer(), options);
      this.dialog.addEventListener('submit', () => this.closeDrawer(false), options);

      this.roots.forEach(root => {
        root.addEventListener('toggle', () => {
          if (!root.open) return;
          const list = root.closest('ul');
          this.roots.forEach(other => {
            if (other !== root && other.closest('ul') === list) other.open = false;
          });
        }, options);

        if (this.desktop.contains(root)) {
          root.addEventListener('pointerenter', event => {
            if (!this.media.matches || event.pointerType !== 'mouse') return;
            clearTimeout(this.leaveTimer);
            this.hoverTimer = setTimeout(() => {
              this.closeDesktop();
              root.open = true;
            }, 130);
          }, options);
          root.addEventListener('pointerleave', () => {
            clearTimeout(this.hoverTimer);
            this.leaveTimer = setTimeout(() => {
              if (!root.contains(document.activeElement)) root.open = false;
            }, 180);
          }, options);
          root.querySelector('summary').addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault();
            this.closeDesktop();
            root.open = true;
            root.querySelector('.mmr-popover a')?.focus();
          }, options);
        }
      });

      this.querySelectorAll('[data-mmr-group]').forEach(group => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          group.parentElement.querySelectorAll(':scope > [data-mmr-group]').forEach(other => {
            if (other !== group) other.open = false;
          });
        }, options);
      });

      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeDesktop();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (this.dialog.open) {
          event.preventDefault();
          this.closeDrawer();
          return;
        }
        const root = this.desktop.querySelector('[data-mmr-root][open]');
        if (root) {
          event.preventDefault();
          this.closeDesktop();
          root.querySelector('summary').focus();
        }
      }, options);
      this.desktop.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.desktop.contains(event.relatedTarget)) this.closeDesktop();
      }, options);
      this.media.addEventListener('change', () => {
        clearTimeout(this.hoverTimer);
        clearTimeout(this.leaveTimer);
        this.closeDesktop();
        if (this.dialog.open) this.closeDrawer(false);
      }, options);
      window.addEventListener('pagehide', () => this.closeDrawer(false), options);
    }

    openDrawer() {
      if (this.media.matches || this.dialog.open) return;
      this.closeDesktop();
      this.dialog.showModal();
      this.dialog.querySelector('.mmr-drawer-header').focus({ preventScroll: true });
      this.opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mmr-menu-modal-open');
    }

    closeDrawer(restoreFocus = true) {
      if (!this.dialog?.open) return;
      this.dialog.close();
      this.releaseDrawer();
      if (restoreFocus && this.isConnected && !this.media.matches) this.opener.focus();
    }

    releaseDrawer() {
      if (this.dialog?.open) return;
      this.opener?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mmr-menu-modal-open');
      this.dialog?.querySelectorAll('details[open]').forEach(details => { details.open = false; });
      const scroll = this.dialog?.querySelector('.mmr-drawer-scroll');
      if (scroll) scroll.scrollTop = 0;
    }

    closeDesktop() {
      this.desktop?.querySelectorAll('[data-mmr-root][open]').forEach(root => { root.open = false; });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.hoverTimer);
      clearTimeout(this.leaveTimer);
      this.closeDrawer(false);
      this.controller?.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmr-diagnose"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mmr-diagnose')) {
  customElements.define('mmr-diagnose', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-diagnose-data]');
      if (!data) return;
      this.ready = true;
      this.d = JSON.parse(data.textContent);
      this.view = this.querySelector('[data-diagnose-view]');
      this.node = 'intro'; this.history = []; this.brand = ''; this.model = ''; this.notes = ''; this.dataNeed = 'data_unknown';
      this.addEventListener('click', e => this.click(e));
      this.addEventListener('submit', e => { if(e.target.matches('[data-device]')) { e.preventDefault(); const f=new FormData(e.target); this.brand=String(f.get('brand')); this.model=String(f.get('model')||'').trim().slice(0,80); this.node='safety'; this.render(true); } });
      this.addEventListener('input', e => {if(e.target.matches('[data-notes]')) this.notes=e.target.value.slice(0,500);});
      this.addEventListener('change', e => { if(e.target.matches('[data-data-need]')) {this.dataNeed=e.target.value; this.querySelector('[data-data-warning]').hidden=this.dataNeed==='data_no';} });
      this.render();
    }
    esc(s) {return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
    text(k) {return this.d.texts[k]||k;}
    u(k) {return this.text(this.d.ui[k]);}
    h(k) {return this.esc(this.u(k));}
    device() {return [this.brand, this.model||this.u('unknown_model')].filter(Boolean).join(' · ');}
    progress() {let stage=this.node==='device'?0:['safety','wet'].includes(this.node)?1:this.node.startsWith('!')?3:2;return `<ol class="md-steps" aria-label="${this.h('progress')}">${['device_step','safety_step','questions_step','result_step'].map((k,i)=>`<li ${i===stage?'aria-current="step"':''} class="${i<stage?'done':''}"><span>${i<stage?'✓':i+1}</span>${this.h(k)}</li>`).join('')}</ol>`;}
    icon(kind) {const paths={phone:'M8 2h8v20H8z M11 18h2',check:'m5 12 4 4 10-10',arrow:'M4 12h16m-6-6 6 6-6 6',shield:'M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6z M8 12l3 3 5-6'};return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${paths[kind]||paths.phone}"/></svg>`;}
    render(focus=false) {
      let content='';
      if(this.node==='intro') content=`<div class="md-intro"><div class="md-lead"><span class="md-kicker">${this.h('eyebrow')}</span><h2 tabindex="-1" data-focus>${this.h('title')}</h2><p>${this.h('intro')}</p><div class="md-badges"><span>${this.icon('check')}${this.h('badge')}</span></div><p class="md-small">${this.h('time')}</p></div><div class="md-start-card"><div class="md-emblem">${this.icon('phone')}</div><p class="md-card-title">${this.h('questions_step')}</p><p>${this.h('disclaimer')}</p><button class="md-primary" data-action="start">${this.h('start')}${this.icon('arrow')}</button><p class="md-small">${this.h('privacy')}</p></div></div>`;
      else {
        content=this.progress()+`<div class="md-topline"><span>${this.esc(this.device())}</span><button class="md-text" data-action="reset">${this.h('reset')}</button></div>`;
        if(this.node==='device') content+=`<form data-device class="md-panel"><span class="md-kicker">${this.h('device_step')}</span><h2 data-focus tabindex="-1">${this.h('brand')}</h2><label class="md-label">${this.h('brand')}<select name="brand" required><option value="">—</option>${[...this.d.brands,this.u('other')].map(b=>`<option value="${this.esc(b)}" ${this.brand===b?'selected':''}>${this.esc(b)}</option>`).join('')}</select></label><label class="md-label">${this.h('model')}<input name="model" value="${this.esc(this.model)}" maxlength="80" placeholder="${this.h('model_placeholder')}" autocomplete="off"></label><p class="md-small">${this.h('model_help')}</p><button class="md-primary" type="submit">${this.h('next')}${this.icon('arrow')}</button></form>`;
        else if(this.node.startsWith('!')) content+=this.result();
        else {
          const n=this.d.nodes[this.node];
          content+=`<div class="md-panel"><span class="md-kicker">${this.h(['safety','wet'].includes(this.node)?'safety_step':'questions_step')}</span><h2 data-focus tabindex="-1">${this.esc(this.text(n.title))}</h2><p class="md-hint">${this.esc(this.text(n.hint))}</p><div class="md-options">${n.options.map((o,i)=>`<button class="md-option" data-option="${i}"><span>${this.esc(this.text(o.label))}</span>${this.icon('arrow')}</button>`).join('')}</div></div>`;
        }
        content+=`<div class="md-bottom"><button class="md-text" data-action="back">← ${this.h('back')}</button>${this.node!=='device'?`<button class="md-text" data-action="safety">${this.icon('shield')}${this.h('safety_short')}</button>`:''}</div>`;
      }
      this.view.innerHTML=content;
      if(focus) this.view.querySelector('[data-focus]')?.focus({preventScroll:true});
    }
    result() {
      const r=this.d.results[this.node.slice(1)], alert=r.kind!=='normal';
      const options=['data_unknown','data_yes','data_no'];
      const searchUrl=(this.getAttribute('data-search-url')||'/search')+'?type=product&q='+encodeURIComponent([this.brand===this.u('other')?'':this.brand,this.model].filter(Boolean).join(' '));
      return `<div class="md-panel md-result"><div class="md-result-head ${alert?'caution':''}"><span class="md-kicker">${this.h(alert?'safety_tag':'result_label')}</span><h2 data-focus tabindex="-1">${this.esc(this.text(r.title))}</h2><p>${this.esc(this.text(r.reason))}</p></div><div class="md-result-body"><h3>${this.h('alternatives')}</h3><p>${this.esc(this.text(r.alternatives))}</p><h3>${this.h('steps')}</h3><ul class="md-advice">${r.steps.map(s=>`<li>${this.esc(this.text(s))}</li>`).join('')}</ul><p class="md-small md-limit">${this.h('disclaimer')}</p>${!alert?`<label class="md-label">${this.h('data')}<select data-data-need>${options.map(k=>`<option value="${k}" ${k===this.dataNeed?'selected':''}>${this.h(k)}</option>`).join('')}</select></label><p class="md-note" data-data-warning ${this.dataNeed==='data_no'?'hidden':''}>${this.h('data_warning')}</p>`:''}<details class="md-details"><summary>${this.h('answers')}</summary><dl><dt>${this.h('device_question')}</dt><dd>${this.esc(this.device())}</dd>${this.history.map(x=>`<dt>${this.esc(this.text(this.d.nodes[x.node].title))}</dt><dd>${this.esc(this.text(this.d.nodes[x.node].options[x.option].label))}</dd>`).join('')}</dl></details><label class="md-label">${this.h('notes')}<textarea data-notes maxlength="500" rows="3" placeholder="${this.h('notes_placeholder')}">${this.esc(this.notes)}</textarea></label><div class="md-actions"><a class="md-primary" href="tel:+494088178768">${this.h('call')}</a>${!alert?`<button class="md-secondary" data-action="email">${this.h('email')}</button>`:''}</div>${!alert?`<p class="md-small">${this.h('email_note')}</p>${this.model?`<a class="md-search" href="${this.esc(searchUrl)}">${this.h('search')} →</a><p class="md-small">${this.h('search_note')}</p>`:''}<a class="md-text" href="https://www.google.com/maps/dir/?api=1&destination=Lange%20Reihe%2066%2020099%20Hamburg">${this.h('visit')} · ${this.h('address')}</a>`:''}<div class="md-save"><button class="md-text" data-action="copy">${this.h('copy')}</button><button class="md-text" data-action="download">${this.h('download')}</button></div><p class="md-small" role="status" data-status></p>${alert?`<a class="md-small" href="${this.node==='!liquid'?'https://support.apple.com/en-us/102643':'https://support.apple.com/guide/iphone/important-safety-information-iph301fc905/ios'}" target="_blank" rel="noopener">${this.h('source_label')}</a>`:''}<p class="md-small">${this.h('result_hint')}</p></div></div>`;
    }
    summary() {
      const r=this.d.results[this.node.slice(1)];
      return [this.u('summary_title'),this.device(),'',...this.history.flatMap(x=>[this.text(this.d.nodes[x.node].title),this.text(this.d.nodes[x.node].options[x.option].label),'']),this.text(r.title),this.text(r.reason),this.u('alternatives')+': '+this.text(r.alternatives),'',this.u('steps'),...r.steps.map(s=>'• '+this.text(s)),'',this.u('data_label')+': '+this.u(this.dataNeed),this.u('notes_label')+': '+(this.notes||'—'),'',this.u('disclaimer')].join('\n');
    }
    async click(e) {
      const b=e.target.closest('button');if(!b||!this.contains(b)) return;
      if(b.dataset.option!==undefined) {const n=this.d.nodes[this.node],i=Number(b.dataset.option);if(!n?.options[i])return;this.history.push({node:this.node,option:i});this.node=n.options[i].next;this.render(true);return;}
      switch(b.dataset.action) {
        case 'start':this.node='device';this.render(true);break;
        case 'back': if(this.node==='device')this.node='intro';else if(this.history.length)this.node=this.history.pop().node;else this.node='device';this.render(true);break;
        case 'safety': this.history=[];this.node='safety';this.render(true);break;
        case 'reset':if(window.confirm(this.u('reset_confirm'))){this.history=[];this.node='intro';this.notes='';this.brand='';this.model='';this.dataNeed='data_unknown';this.render(true);}break;
        case 'copy':try{await navigator.clipboard.writeText(this.summary());this.querySelector('[data-status]').textContent=this.u('copied');}catch{this.querySelector('[data-status]').textContent=this.u('copy_failed');}break;
        case 'download':{const url=URL.createObjectURL(new Blob([this.summary()],{type:'text/plain;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='My-Mobile-Repair-Geraetecheck.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);break;}
        case 'email':window.location.href='mailto:info@mymobilerepair.de?subject='+encodeURIComponent(this.u('email_subject')+' · '+this.device())+'&body='+encodeURIComponent(this.summary());break;
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
